"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by vadimdez on 28/11/2016.
 */
__export(require("./src/ng2-filter.module"));
__export(require("./src/ng2-filter.pipe"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-filter-pipe/dist/index.js
// module id = 1120
// module chunks = 323